import React from 'react';
import classNames from 'classnames';
import { FsLinkText, FsText } from '@finalsite/wc-react';
import queryString from 'query-string';

/*
Side navigation bar for Fusion Forms.  Should list every page in the form, and highlight the current page.
@param form - the form object, which contains the template and pages
@param page - the current page number (1-indexed)
 */
export const Navigation = ({ form, page }) => {
  // No navigation if there's only one page.
  if(form.template.pages.length <= 1) {
    return <></>;
  }

  const pages = form?.template?.pages || [];
  const currentQuery = queryString.parse(window.location.search);

  return <>
    <div className={'form-nav'}>
      {
        pages.map((pageObj, index) =>
          {
            const pageIndex = index + 1; // Convert to 1-indexed
            const active = pageIndex === page;
            const pageUrl = `${window.location.pathname}?${queryString.stringify({ ...currentQuery, page: pageIndex })}`;

            if (pageIndex < page) {
              return (
                <FsLinkText className={classNames('form-nav-item', {active})}
                            weight={active ? 'bold' : 'normal'}
                            href={pageUrl}
                            key={index}
                >
                  {pageObj.name || `Page ${index + 1}`}
                </FsLinkText>
              );
            }
            else {
              return (
                <FsText className={classNames('form-nav-item', {active})}
                        weight={active ? 'bold' : 'normal'}
                        key={index}
                >
                  {pageObj.name || `Page ${index + 1}`}
                </FsText>
              )
            }
          }
        )
      }
    </div>
  </>
};
